var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRelatorio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 22V20.5H19.5V19.75H18V18.25H19.5V17.5H17V16H20C20.2833 16 20.5208 16.0958 20.7125 16.2875C20.9042 16.4792 21 16.7167 21 17V18C21 18.2833 20.9042 18.5208 20.7125 18.7125C20.5208 18.9042 20.2833 19 20 19C20.2833 19 20.5208 19.0958 20.7125 19.2875C20.9042 19.4792 21 19.7167 21 20V21C21 21.2833 20.9042 21.5208 20.7125 21.7125C20.5208 21.9042 20.2833 22 20 22H17ZM17 15V12.25C17 11.9667 17.0958 11.7292 17.2875 11.5375C17.4792 11.3458 17.7167 11.25 18 11.25H19.5V10.5H17V9H20C20.2833 9 20.5208 9.09583 20.7125 9.2875C20.9042 9.47917 21 9.71667 21 10V11.75C21 12.0333 20.9042 12.2708 20.7125 12.4625C20.5208 12.6542 20.2833 12.75 20 12.75H18.5V13.5H21V15H17ZM18.5 8V3.5H17V2H20V8H18.5ZM3 18.775V17.275H14.775V18.775H3ZM3 12.7V11.2H14.775V12.7H3ZM3 6.625V5.125H14.775V6.625H3Z",
    fill: "url(#paint0_linear_47_427)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_47_427",
    x1: 12,
    y1: 2,
    x2: 12,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D81C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2594BD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelatorio);
export default __webpack_public_path__ + "static/media/relatorio.69c2a7c7f26e917735495ff288bb1b54.svg";
export { ForwardRef as ReactComponent };